import { motion } from "framer-motion";

export default function TimerIcon({ remainingTime, maxTimeLimit }) {
  return (
    <motion.svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      fill="currentColor"
      className="bi bi-stopwatch-fill"
      viewBox="0 0 16 16"
      aria-label="stop watch image"
      animate={
        (remainingTime === maxTimeLimit && {
          scale: [1.5, 1],
          transition: { duration: 1.5 },
        }) ||
        (remainingTime === 10 && {
          y: [10, -10, 10, -10, 0],
          transition: { type: "spring", stiffness: 750 },
        })
      }
    >
      <path d="M6.5 0a.5.5 0 0 0 0 1H7v1.07A7.001 7.001 0 0 0 8 16a7 7 0 0 0 5.29-11.584l.013-.012.354-.354.353.354a.5.5 0 1 0 .707-.707l-1.414-1.415a.5.5 0 1 0-.707.707l.354.354-.354.354-.012.012A6.97 6.97 0 0 0 9 2.071V1h.5a.5.5 0 0 0 0-1zm2 5.6V9a.5.5 0 0 1-.5.5H4.5a.5.5 0 0 1 0-1h3V5.6a.5.5 0 1 1 1 0" />
    </motion.svg>
  );
}
